export default {
  title: 'Ustawienia filtra',
  timeInterval: 'Przedział czasu',
  additionalFilters: 'Dodatkowe filtry',
  noWeekdaysNotification: 'Należy wybrać co najmniej jeden dzień tygodnia',
  lagging: {
    lagging: 'Otulina',
    isLagging: {
      true: 'Tylko wykryto',
      false: 'Tylko zatrzymane',
    },
    all: 'Wykryto i zatrzymano',
  },
  newState: 'Nowy stan',
  assignee: 'Przypisany do',
  created: 'Stworzone przez',
};
